import styled from 'styled-components';
import { getColor } from 'core/utils/Styles';
import { resetBtn, size } from 'styled-manila';

export const Buttons = styled.div`
	display: flex;
`;

export const Button = styled.button`
	${resetBtn}
	display: flex;
	align-items: center;
	border-radius: 4px;
	height: 40px;
	color: ${getColor('white')};
	background-color: ${getColor('concreteGray')};
	width: 100%;
	transition: 0.2s;
	max-width: 130px;
	margin: 0 auto;
`;

export const FacebookBtn = styled(Button)`
	background-color: ${getColor('facebook')};

	&:hover, &:focus {
		background-color: ${getColor('facebookHover')};
		color: ${getColor('white')};
	}
`;

export const GoogleBtn = styled(Button)`
	background-color: ${getColor('google')};
	margin-left: 10px;

	&:hover, &:focus {
		background-color: ${getColor('googleHover')};
	}
`;

export const Text = styled.span`
	font-weight: 600;
	font-size: 15px;
	padding-left: 15px;
	margin-top: auto;
	margin-bottom: auto;
`;

export const IconWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	${size(37, 40)}
	border-right: 1px solid rgba(255, 255, 255, 0.2);
	font-size: 18px;

	svg {
		${size('1em')}
	}
`;
